import { createSelector } from 'reselect'
import StoreState from 'store/state'

const contentPopupSelector = (state: StoreState) => state.contentPopup
export const contentPopupActiveSelector = createSelector(contentPopupSelector, (popup) => popup.open)
export const contentPopupItemsSelector = createSelector(contentPopupSelector, (popup) => popup.items)
